<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        My Targets and Competitions
      </h5>
    </div>

    <LoadingSpinner v-if="loading"/>

    <div v-else class="panel-body">
      <div v-if="participations.length">
        <div v-for="(participation,index) in participationsWithStars" :style="{
          backgroundColor:'#eeeeee',
          borderRadius: '4px',
          padding: '8px',
          marginTop: index > 0 ?  '16px' : ''
        }">
          <div class="tw-flex tw-justify-between">
            <h4 class="tw-my-0">
              {{ participation.attributes.competition_name }}
            </h4>

            <div>
              <router-link :to="'/dashboards/competitions?id=' + participation.attributes.competition_id">
                <i class="fa fa-search"></i>
              </router-link>
            </div>
          </div>

          <div v-if="participation.attributes.current_progress" class="tw-mt-8">
            <div>
              Value: {{ participation.attributes.current_progress.value | price }}&nbsp;&middot;&nbsp;Target: {{ participation.attributes.current_progress.target | price }}&nbsp;&middot;&nbsp;Difference:
              {{ participation.attributes.current_progress.value - participation.attributes.current_progress.target | price }} &middot; Index: {{ Math.round(participation.attributes.current_progress.value / participation.attributes.current_progress.target * 100) }}
            </div>

            <div :style="{backgroundColor: getCompetitionBackgroundColor(participation), display: 'flex', borderRadius: '4px', overflow: 'hidden'}" class="tw-mt-4">
              <div :style="{width: '25%', borderRight: '1px solid #ffffff'}">
                <div :style="{backgroundColor: getCompetitionActiveColor(participation), textAlign: 'center', width: getProgressWidth(participation, 0) + '%'}">
                  &nbsp;
                </div>
              </div>

              <div :style="{width: '25%', borderRight: '1px solid #ffffff'}">
                <div :style="{backgroundColor: getCompetitionActiveColor(participation), textAlign: 'center', width: getProgressWidth(participation, 1) + '%'}">
                  &nbsp;
                </div>
              </div>

              <div :style="{width: '25%', borderRight: '1px solid #ffffff'}">
                <div :style="{backgroundColor: getCompetitionActiveColor(participation), textAlign: 'center', width: getProgressWidth(participation, 2) + '%'}">
                  &nbsp;
                </div>
              </div>

              <div style="width: 25%">
                <div :style="{backgroundColor: getCompetitionActiveColor(participation), textAlign: 'center', width: getProgressWidth(participation, 3) + '%'}">
                  &nbsp;
                </div>
              </div>
            </div>
          </div>

          <div v-if="participation.attributes.competition_driver === 'advertising-stars' || participation.attributes.competition_driver === 'partnership-stars'" class="tw-mt-2">
            {{ businessDaysRemaining }}/{{ businessDaysInMonth }} days remaining.
          </div>
        </div>

        <div v-if="participationsWithoutStars.length">
          <div style="border-bottom: 1px solid #e1e1e1; padding: 16px; margin-left: -16px; margin-right: -16px;">
            <h5>
              Other targets and competitions
            </h5>
          </div>

          <table class="table">
            <thead>
            <tr>
              <th class="tw-w-1/2">
                Title
              </th>
              <th class="tw-w-1/4">
                My Sale
              </th>
              <th class="tw-w-1/4">
                Days remaining
              </th>
              <th> </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="participation in participationsWithoutStars">
              <td class="table__ellipsis">
                  {{ participation.attributes.competition_name }}
              </td>

              <td>
                {{ getFormattedScore(participation) }}
              </td>

              <td>
                {{ getBusinessDaysRemaining(participation) }}
              </td>

              <td>
                <router-link :to="'/dashboards/competitions?id=' + participation.attributes.competition_id">
                  <i class="fa fa-search"></i>
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else class="tw-flex tw-items-center tw-justify-center tw-h-20">
        You are currently not part of any competitions.
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import moment from "moment/moment";

export default {
  components: {LoadingSpinner},

  data() {
    return {
      participations: null,

      loading: true,

      shared: store
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    businessDaysInMonth() {
      let current = moment().startOf('month')

      let count = 0

      while (current <= moment().endOf('month')) {
        if (current.format('E') !== '6' && current.format('E') !== '7') {
          count++
        }

        current = current.add(1, 'days')
      }

      return count
    },

    businessDaysRemaining() {
      let current = moment().startOf('day')

      let count = 0

      while (current < moment().endOf('month')) {
        if (current.format('E') !== '6' && current.format('E') !== '7') {
          count++
        }

        current = current.add(1, 'days')
      }

      return count
    },

    participationsWithStars() {
      return this.participations.filter(participation => ["stars","advertising-stars","partnership-stars"].includes(participation.attributes.competition_driver))
    },

    participationsWithoutStars() {
      return this.participations.filter(participation => !["stars","advertising-stars","partnership-stars"].includes(participation.attributes.competition_driver))
    }
  },

  methods: {
    load() {
      http.get('/api/v2/users/' + this.shared.user.id + '/participations').then(response => {
        this.participations = response.data.data

        this.loading = false
      })
    },

    getCompetitionBackgroundColor(participation) {
      if (participation.attributes.competition_driver === 'partnership-stars') {
        return '#bfdbfe';
      }

      return '#bbf7d0';
    },

    getCompetitionActiveColor(participation) {
      if (participation.attributes.competition_driver === 'partnership-stars') {
        return '#2563eb';
      }

      return '#16a34a';
    },

    getProgressWidth(participation, index) {
      return Math.max(Math.min((participation.attributes.current_progress.value - (participation.attributes.current_progress.target / 4) * index) / (participation.attributes.current_progress.target / 4), 1), 0) * 100
    },

    getFormattedScore(participation) {
      if (participation.attributes.competition_score_unit === 'number') {
        return this.$options.filters.number(participation.attributes.score)
      }

      if (participation.attributes.competition_score_unit === 'money') {
        return this.$options.filters.price(participation.attributes.score)
      }

      if (participation.attributes.competition_score_unit === 'stars') {
        return '&starf; ' + participation.attributes.score
      }

      return participation.attributes.score
    },

    getBusinessDaysRemaining(participation) {
      let current = moment().startOf('day')

      let count = 0

      while (current < moment(participation.attributes.competition_ends_at)) {
        if (current.format('E') !== '6' && current.format('E') !== '7') {
          count++
        }

        current = current.add(1, 'days')
      }

      return count
    }
  }
}
</script>
